export default "__VITE_ASSET__BbG258iU__"